import { useQuery } from '@tanstack/react-query'
import { expensesApi } from '../../api/expensesApi'
import { EXPENSES } from '../../constants/endpoints'

export const useExpenseReceiptQuery = (
  expenseId: string,
  expenseItemId: string,
  enabled: boolean,
) => {
  return useQuery({
    queryFn: async () => {
      const response = await expensesApi.downloadReceipt(
        expenseId,
        expenseItemId,
      )
      const blob = response.data
      return { url: URL.createObjectURL(blob), mimeType: blob.type }
    },
    queryKey: [EXPENSES, 'receipt', expenseId, expenseItemId],
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  })
}
